// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__33fK4","title":"ClientReferral_title__3AzsY","itemText":"ClientReferral_itemText__2XvxF"};